module.exports = "\r\n<!--created by AHMED HAYEL-->\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-component/dashboard/dashboard.component.html
// module id = 383
// module chunks = 1